import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchSecteurs } from "../../../store/actions/autreActions"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import { tableStyles } from "../../styles/tableStyles"
import Loader from "../../basics/Loader"
import SecteurModalV2 from "./SecteurModalV2"

const styles = {
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: 16,
	},
	title: { fontSize: 15, fontWeight: 600, color: COLORS.text },
	count: { fontSize: 13, color: COLORS.textLight },
	empty: {
		...tableStyles.empty,
		padding: "40px 16px",
		color: COLORS.textLight,
		fontSize: 14,
	},
	section: { marginBottom: 32 },
}

const Row = ({ children, index, onOpen, item }) => {
	const [hover, setHover] = useState(false)
	const bg = hover ? tableStyles.rowHover : tableStyles.rowBg(index)
	return (
		<tr
			onDoubleClick={() => onOpen(item)}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			style={{
				backgroundColor: bg,
				cursor: "pointer",
				transition: "background-color 0.12s",
			}}
		>
			{children}
		</tr>
	)
}

// Onglet "Secteurs" de la Configuration — deux référentiels distincts :
//  • Secteurs géographiques : libellé + codes postaux (mapping futur lieu→secteur).
// (Les « secteurs police » ne sont plus un référentiel : lieu d'intervention
// police = enum en dur, cf. SECTEURS_POLICE / LIEU_POLICE_* — GE-7.)
const SecteursV2 = () => {
	const dispatch = useDispatch()
	const secteurs = useSelector((s) => s.autreInfo.secteurs)
	const fetchState = useSelector((s) => s.autreInfo.fetchSecteurs)
	const [editingGeo, setEditingGeo] = useState(null)

	useEffect(() => {
		dispatch(fetchSecteurs())
	}, [dispatch])

	const geo = [...(secteurs || [])].sort((a, b) =>
		(a.nom || "").localeCompare(b.nom || "", "fr"),
	)
	const loading = fetchState.loading && geo.length === 0

	return (
		<>
			{editingGeo && (
				<SecteurModalV2
					secteur={editingGeo}
					onClose={() => setEditingGeo(null)}
				/>
			)}

			{/* ===== Secteurs géographiques ===== */}
			<div style={styles.section}>
				<div style={styles.header}>
					<div
						style={{ display: "flex", alignItems: "baseline", gap: 10 }}
					>
						<span style={styles.title}>Secteurs géographiques</span>
						<span style={styles.count}>{geo.length}</span>
					</div>
					<button
						style={gs.btnPrimary}
						onClick={() => setEditingGeo({})}
					>
						+ Nouveau secteur
					</button>
				</div>
				<div style={tableStyles.container}>
					{loading ? (
						<Loader variant="ring" message="Chargement…" />
					) : geo.length === 0 ? (
						<div style={styles.empty}>Aucun secteur géographique.</div>
					) : (
						<table style={tableStyles.table}>
							<thead>
								<tr>
									<th style={tableStyles.th}>Nom</th>
									<th style={tableStyles.th}>Codes postaux</th>
								</tr>
							</thead>
							<tbody>
								{geo.map((secteur, index) => (
									<Row
										key={secteur.id}
										index={index}
										item={secteur}
										onOpen={setEditingGeo}
									>
										<td
											style={{
												...tableStyles.td,
												fontWeight: 500,
											}}
										>
											{secteur.nom || "—"}
										</td>
										<td style={tableStyles.td}>
											{(secteur.codes || [])
												.map((c) => c.code)
												.join(", ") || "—"}
										</td>
									</Row>
								))}
							</tbody>
						</table>
					)}
				</div>
			</div>

		</>
	)
}

export default SecteursV2
